<template>
  <div class="record-modal">
    <van-overlay :show="visible" :lock-scroll="false" :z-index="300">
      <div class="wrapper" >
        <div class="card" @click.stop>
          <div class="table">
            <div class="thead">
              <div class="th name">奖品</div>
              <div class="th date">领取日期</div>
            </div>
            <div class="tbody">
              <div class="tr" v-for="(item, idx) in list" :key="idx">
                <div class="top" @click="onItemClick(item)">
                  <div class="td name">{{ item.stockName }}</div>
                  <div class="td date">{{ item.createTime }}</div>
                </div>
                <!-- receiveType领取类型，1-微信立减金，2-券仓商品，3-积分商品，4-实物商品，5-白鹭积分-->
                <div
                  v-if="item.receiveType === 4 && item.logisticsInfo"
                  class="td extra"
                >
                  <span class="label">物流单号：</span>
                  <span class="text">{{ item.logisticsInfo }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.logisticsInfo)"
                  >
                    复制
                  </van-button>
                </div>
                <div v-if="item.receiveType === 2" class="td extra">
                  <span class="label">卡号：</span>
                  <span class="text">{{ item.cardCode }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.cardCode)"
                  >
                    复制
                  </van-button>
                </div>
                <div v-if="item.receiveType === 2" class="td extra">
                  <span class="label">卡密：</span>
                  <span class="text">{{ item.cardPwd }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.cardPwd)"
                  >
                    复制
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          class="close-btn"
          type="button"
          aria-label="关闭"
          @click.stop="onClose"
        >
          <img :src="imgClose" alt="" />
        </button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { luyuanNewCustomerGetRecordPages } from '@/api/luyuan'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
export default {
  name: 'RecordModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      imgClose: require('@/assets/imgs/xibMaintain/record-modal-close.png'),
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.loadData()
        }
      },
      immediate: false
    }
  },
  methods: {
    onItemClick(item) {
      // receiveType领取类型，1-微信立减金，2-券仓商品，3-积分商品，4-实物商品，5-白鹭积分
      if ([4].includes(item.receiveType)) {
        this.$router.push({
          path: '/luyuanNewCustomerGiftPhysicalDetail',
          query: { id: item.id }
        })
      } else {
        this.$router.push({
          path: '/luyuanNewCustomerGiftDetail',
          query: { id: item.id }
        })
      }
    },
    async loadData() {
      const { data } = await luyuanNewCustomerGetRecordPages({
        pageNum: 1,
        pageSize: 100,
        param: {}
      })
      this.list = data.records
    },
    onClose() {
      this.$emit('confirm')
    },
    async copy(text) {
      try {
        await toClipboard(text)
        console.log('Copied to clipboard')
        this.$toast.success('复制成功!')
      } catch (e) {
        console.error(e)
        this.$toast.fail('复制失败!')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.record-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    box-sizing: border-box;
  }
  .card {
    width: 320px;
    max-height: 430px;
    background: url('~@/assets/imgs/xibNewCustomerGift/luyuanRecordModalBg.png') no-repeat;
    background-size: 100% auto;
    border-radius: 18px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    padding: 0 10px 18px;
    box-sizing: border-box;
    position: relative;
    .table {
      margin-top: 80px;
      background: #ffffff;
      border-radius: 20px;
      padding: 12px 10px 10px;
      min-height: 60px;
      .thead {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background: #BCF4F6;
        border-radius: 7px;
        color: #1B899F;
        font-weight: 600;
        font-size: 12px;
        padding: 0px 35px;
        .th {
          padding: 8px 10px;
        }
        .name {
          text-align: left;
          color: #1B899F;
        }
        .date {
          text-align: right;
        }
      }
      .tbody {
        max-height: 300px;
        box-sizing: border-box;
        overflow-y: auto;
        .tr {
          border-bottom: 1px solid #e6e6e6;
          padding: 10px 0;
          &:last-child {
            border-bottom: none;
          }
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .td {
            padding: 0 6px;
            font-size: 14px;
          }
          .name {
            padding-top: 2px;
            color: #000000;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 1.4;
            word-break: break-all;
            flex: 1;
          }
          .date {
            text-align: right;
            color: #999999;
          }
          .extra {
            display: flex;
            align-items: center;
            margin-top: 6px;
            .label {
              color: #1B899F;
              font-size: 12px;
              margin-right: 4px;
            }
            .text {
              flex: 1;
              font-size: 12px;
              color: #1B899F;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 8px;
            }
            .copy-btn {
              width: 48px;
              height: 24px;
              line-height: 24px;
              border-radius: 5px;
              font-size: 12px;
              background: #1B899F;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .close-btn {
    margin-top: 49px;
    padding: 0;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    img {
      display: block;
      width: 29px;
      height: 29px;
    }
  }
}
</style>
